<section class="section bg-light d-table w-100" style="background: url('../../assets/images/background/build.png') bottom no-repeat;">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-md-6">
        <div class="title-heading">
          <h4 class="heading my-3">
            {{ 'Signup.SellMore' | translate }}
            <br>
           <span class="font-weight-normal"> {{ 'Signup.GetPaid' | translate }} </span>
          </h4>
          <p class="para-desc text-muted">
            {{ 'Signup.Description' | translate }}
          </p>
        </div>
      </div>

      <div class="col-md-6 mt-4 pt-2 pt-sm-0">
        <div class="card shadow rounded border-0 ms-lg-4">
          <div class="card-body">
            <ng-content></ng-content>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
